import { useState } from 'react';

import { Project, Resource } from '@/types/types';

import { ResourcePlaceholderAssign } from './ResourcePlaceholderAssign';

type UseResourcePlaceholderAssignProps = {
  resourceId: Resource['id'];
  projectId?: Project['id'];
  onSuccess?: () => void;
};

export function useResourcePlaceholderAssign({
  resourceId,
  projectId,
  onSuccess,
}: UseResourcePlaceholderAssignProps) {
  const [opened, setOpened] = useState(false);

  const open = () => setOpened(true);
  const close = () => setOpened(false);

  const Drawer = () => (
    <ResourcePlaceholderAssign
      opened={opened}
      onClose={close}
      resourceId={resourceId}
      projectId={projectId}
      onSuccess={onSuccess}
    />
  );

  return {
    open,
    close,
    Drawer,
  };
}
